export default "assets/images/icons/alcool-8828d2f2.svg";